/* GPX-CRO START: gpx-cro.js -- "كمّل الطقم" offer block.
   Vanilla JS, no dependencies. Safe to delete this file (and its <script> tag
   in snippets/gpx-cro-progress.liquid) to remove the whole feature.
   Reads /cart.js (Shopify's storefront cart JSON, no auth needed) and renders
   the same live state into every [data-gpx-cro] element found on the page
   (PDP block, cart drawer, cart page).

   2026-09-15 rewrite: the old version drew "1 -> 2 -> 3" as one continuous
   milestone bar, which read as if both live discounts stack (2nd item 50%
   off AND 3rd item free, together). They don't -- both are non-combining
   BXGY discounts on the same collections, confirmed on the live checkout:
   >=3 eligible items in cart => only "Buy 2 Get 1 Free" applies and the 50%
   credit is fully replaced, not kept. Per Ahmed: two separate progress bars
   (same look as the old single bar), each filling toward its own target
   (2 / 3 items); only the lane the cart currently qualifies for gets a
   subtle active state + the real EGP saving. Saving is cart.total_discount
   (exact, once Shopify has computed it) in drawer/cart_page, or a clearly
   shorter "≈" estimate on the PDP with an empty cart. See
   optimization/progress_bar/REPORT_2026-09-15.md for the verified numbers. */
(function () {
  "use strict";

  function formatMoney(cents) {
    if (typeof cents !== "number" || isNaN(cents)) return "";
    var egp = Math.round(cents / 100);
    var withCommas = egp.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
    return "LE " + withCommas;
  }

  function cheapestFinalPrice(items) {
    if (!items || !items.length) return 0;
    var min = items[0].final_price;
    for (var i = 1; i < items.length; i++) {
      if (items[i].final_price < min) min = items[i].final_price;
    }
    return min;
  }

  function renderEl(el, cart) {
    var context = el.getAttribute("data-gpx-cro-context");
    var itemCount = cart.item_count || 0;
    var displayCount = context === "pdp" ? itemCount + 1 : itemCount;
    var isExact = context !== "pdp";

    var fill1 = el.querySelector('[data-gpx-cro-fill="1"]');
    var fill2 = el.querySelector('[data-gpx-cro-fill="2"]');
    var bar1 = el.querySelector('[data-gpx-cro-bar="1"]');
    var bar2 = el.querySelector('[data-gpx-cro-bar="2"]');
    var lane1 = el.querySelector('[data-gpx-cro-lane="1"]');
    var lane2 = el.querySelector('[data-gpx-cro-lane="2"]');
    var save1 = el.querySelector("[data-gpx-cro-lane1-save]");
    var save2 = el.querySelector("[data-gpx-cro-lane2-save]");
    var freeshipEl = el.querySelector("[data-gpx-cro-freeship]");
    var ctaEl = el.querySelector("[data-gpx-cro-cta]");

    var pct1 = Math.max(0, Math.min(2, displayCount)) / 2 * 100;
    var pct2 = Math.max(0, Math.min(3, displayCount)) / 3 * 100;
    if (fill1) fill1.style.width = pct1 + "%";
    if (fill2) fill2.style.width = pct2 + "%";
    if (bar1) bar1.setAttribute("aria-valuenow", String(Math.min(2, displayCount)));
    if (bar2) bar2.setAttribute("aria-valuenow", String(Math.min(3, displayCount)));

    var cheapest = cheapestFinalPrice(cart.items);
    var pdpPrice = parseInt(el.getAttribute("data-pdp-price") || "0", 10);
    var refPrice = cheapest > 0 ? cheapest : pdpPrice;

    if (lane1) lane1.classList.remove("is-active");
    if (lane2) lane2.classList.remove("is-active");
    if (save1) save1.textContent = "";
    if (save2) save2.textContent = "";

    if (displayCount >= 3) {
      if (lane2) lane2.classList.add("is-active");
      if (save2) {
        save2.textContent = isExact && cart.total_discount > 0
          ? "−" + formatMoney(cart.total_discount)
          : (refPrice > 0 ? "≈ −" + formatMoney(refPrice) : "");
      }
    } else if (displayCount === 2) {
      if (lane1) lane1.classList.add("is-active");
      if (save1) {
        save1.textContent = isExact && cart.total_discount > 0
          ? "−" + formatMoney(cart.total_discount)
          : (refPrice > 0 ? "≈ −" + formatMoney(Math.round(refPrice * 0.5)) : "");
      }
    }

    if (freeshipEl) {
      var freeshipEnable = el.getAttribute("data-freeship-enable") === "true";
      var freeshipAmount = parseInt(el.getAttribute("data-freeship-amount") || "0", 10);
      if (freeshipEnable && freeshipAmount > 0) {
        freeshipEl.hidden = false;
        if (cart.total_price >= freeshipAmount) {
          freeshipEl.textContent = "مبروك — خدت الشحن المجاني ✅";
        } else {
          freeshipEl.textContent = "شحن مجاني فوق " + formatMoney(freeshipAmount) + " (باقي " + formatMoney(freeshipAmount - cart.total_price) + ")";
        }
      } else {
        freeshipEl.hidden = true;
      }
    }

    if (ctaEl) { ctaEl.hidden = itemCount === 0; }

    /* upsell row (drawer + cart page) */
    var up = el.querySelector("[data-gpx-cro-upsell]");
    if (up) {
      if (itemCount > 0 && itemCount < 3 && cart.items && cart.items.length) {
        up.hidden = false;
        loadUpsell(up, cart.items[0].product_id, cart.items.map(function (i) { return i.product_id; }));
      } else { up.hidden = true; }
    }
  }

  var upsellCache = {};
  function loadUpsell(box, productId, inCart) {
    var row = box.querySelector("[data-gpx-cro-upsell-row]");
    if (!row || row.getAttribute("data-for") === String(productId)) return;
    row.setAttribute("data-for", String(productId));
    var done = function (products) {
      row.innerHTML = "";
      products.filter(function (p) { return p.available && inCart.indexOf(p.id) === -1; }).slice(0, 6).forEach(function (p) {
        var avail = p.variants.filter(function (v) { return v.available; });
        var card = document.createElement("div"); card.className = "gpx-cro__up";
        var img = document.createElement("img"); img.loading = "lazy"; img.alt = p.title;
        var src = p.featured_image || (p.images && p.images[0]) || "";
        img.src = src.replace(/(\.[a-z]+)(\?|$)/i, "_300x$1$2");
        var t = document.createElement("div"); t.className = "gpx-cro__up-t"; t.textContent = p.title;
        var pr = document.createElement("div"); pr.className = "gpx-cro__up-p"; pr.textContent = formatMoney(p.price);
        card.appendChild(img); card.appendChild(t); card.appendChild(pr);
        if (avail.length === 1) {
          var b = document.createElement("button"); b.type = "button"; b.className = "gpx-cro__up-btn"; b.textContent = "+ ضيف للسلة";
          b.addEventListener("click", function () {
            b.disabled = true; b.textContent = "…";
            fetch("/cart/add.js", { method: "POST", headers: { "Content-Type": "application/json" }, body: JSON.stringify({ id: avail[0].id, quantity: 1 }) })
              .then(function () { b.textContent = "اتضافت ✅"; })
              .catch(function () { b.disabled = false; b.textContent = "+ ضيف للسلة"; });
          });
          card.appendChild(b);
        } else {
          var a = document.createElement("a"); a.className = "gpx-cro__up-btn is-link"; a.href = "/products/" + p.handle; a.textContent = "اختار المقاس";
          card.appendChild(a);
        }
        row.appendChild(card);
      });
      if (!row.children.length) box.hidden = true;
    };
    if (upsellCache[productId]) return done(upsellCache[productId]);
    fetch("/recommendations/products.json?product_id=" + productId + "&limit=8&intent=related")
      .then(function (r) { return r.json(); })
      .then(function (d) { upsellCache[productId] = d.products || []; done(upsellCache[productId]); })
      .catch(function () { box.hidden = true; });
  }

  function renderAll(cart) {
    var els = document.querySelectorAll("[data-gpx-cro]");
    for (var i = 0; i < els.length; i++) renderEl(els[i], cart);
  }

  function refresh() {
    return fetch("/cart.js", { credentials: "same-origin" })
      .then(function (r) { return r.json(); })
      .then(function (cart) {
        renderAll(cart);
        document.dispatchEvent(new CustomEvent("gpx:cart", { detail: cart }));
        return cart;
      })
      .catch(function () {});
  }

  function scrollToUpsell(drawerEl) {
    var target = drawerEl.querySelector("[data-cart-upsell-options], .t4s-minicart-recommendations");
    if (!target) {
      var scroller = drawerEl.querySelector("[data-t4s-scroll-me]");
      if (scroller) scroller.scrollTo({ top: scroller.scrollHeight, behavior: "smooth" });
      return;
    }
    target.scrollIntoView({ behavior: "smooth", block: "center" });
  }

  document.addEventListener("click", function (e) {
    var btn = e.target.closest && e.target.closest("[data-gpx-cro-cta]");
    if (!btn) return;
    var drawer = document.getElementById("t4s-mini_cart");
    if (drawer) scrollToUpsell(drawer);
  });

  /* No documented custom cart-update event exists in this theme (checked
     assets/global.min.js), so we watch fetch() calls to /cart/* endpoints
     and re-read /cart.js right after they resolve. */
  var nativeFetch = window.fetch;
  if (typeof nativeFetch === "function" && !window.__gpxCroFetchWrapped) {
    window.__gpxCroFetchWrapped = true;
    window.fetch = function (input, init) {
      var url = typeof input === "string" ? input : (input && input.url) || "";
      var isCartCall = url.indexOf("/cart/add") > -1 ||
        url.indexOf("/cart/change") > -1 ||
        url.indexOf("/cart/update") > -1 ||
        url.indexOf("/cart/clear") > -1;
      var result = nativeFetch.apply(this, arguments);
      if (isCartCall) {
        result.then(function () { setTimeout(refresh, 50); }).catch(function () {});
      }
      return result;
    };
  }

  document.addEventListener("submit", function (e) {
    var form = e.target;
    if (form && form.getAttribute && form.getAttribute("data-type") === "add-to-cart-form") {
      setTimeout(refresh, 400);
    }
  });

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", refresh);
  } else {
    refresh();
  }
})();
/* GPX-CRO END: gpx-cro.js */
